import ConnectApi from "../../baseService"
import {
  TKaikonZyutyuHaisyaPatternListGetReq,
  TKaikonZyutyuHaisyaPatternListGetRes,
  TKaikonZyutyuHaisyaPatternGetRes,
} from "./TKaikonZyutyuHaisyaPattern"
import { TApiResponse } from "../../TApiResponse"
import { AxiosResponse } from "axios"

/**
 * 海コン受注配車に対するAPIリクエスト用サービス
 *
 * @export
 * @class KaikonZyutyuHaisyaPatternService
 * @extends {ConnectApi}
 */
export default class KaikonZyutyuHaisyaPatternService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof KaikonZyutyuHaisyaPatternService
   */
  getList = async (params: TKaikonZyutyuHaisyaPatternListGetReq) => {
    try {
      const res: AxiosResponse<
        TApiResponse<TKaikonZyutyuHaisyaPatternListGetRes[]>
      > = await this.getInner(
        `/ordercontainer/kaikonzyutyuhaisyapattern`,
        params
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 単体取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof KaikonZyutyuHaisyaPatternService
   */
  get = async (id: string | number) => {
    try {
      const res: AxiosResponse<TApiResponse<TKaikonZyutyuHaisyaPatternGetRes>> =
        await this.getInner(`/ordercontainer/kaikonzyutyuhaisyapattern/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TKaikonZyutyuHaisyaPatternGetRes} data
   * @memberof KaikonZyutyuHaisyaPatternService
   */
  post = async (data: TKaikonZyutyuHaisyaPatternGetRes) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/ordercontainer/kaikonzyutyuhaisyapattern/`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TKaikonZyutyuHaisyaPatternGetRes} data
   * @memberof KaikonZyutyuHaisyaPatternService
   */
  put = async (id: string, data: TKaikonZyutyuHaisyaPatternGetRes) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/ordercontainer/kaikonzyutyuhaisyapattern/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * グリッド登録
   *
   * @param {TMenuInfoGetReq} params
   * @memberof MenuService
   */
  postPattern = async (id: number, param: { パターンコード: string }) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/ordercontainr/kainkonzyutyuhaisya/actions/postpattern/${id}`,
        param
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体削除
   *
   * @param {TKaikonZyutyuHaisyaPatternGetRes} data
   * @memberof KaikonZyutyuHaisyaPatternService
   */
  delete = async (id: string) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/ordercontainer/kaikonzyutyuhaisyapattern/actions/delete/${id}`,
        id
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
